import ky from 'ky';
import Config from './config';
import type { IndexesData } from './xoonips/lib/IndexUtil';

/**
 * Data converted from the original XOOPS modules. It is served with the rest of
 * static-contents/ rather than bundled, so the part every page needs is fetched
 * once at start up and handed to the singletons before the app renders. The
 * pico, bulletin and credits modules load their own data on demand.
 */
export interface SiteData {
    tree: IndexesData;
}

// ky hands the URL to fetch()/Request, which rejects bare relative paths.
const resolve = (path: string): string => new URL(Config.BASE_URL + path, window.location.href).toString();

export const loadSiteData = async (): Promise<SiteData> => {
    const tree = await ky.get(resolve('/modules/xoonips/tree.json')).json<IndexesData>();
    return { tree };
};
